import {
  Box,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TerminationLetterOpions } from 'src/utils/constants/contracts';
import { Send } from '@mui/icons-material';
import ConfirmationDialog from 'src/components/ConfirmDialog/ConfirmationDialog';
import AlertMessage from 'src/components/Alert/Alert';
import AlertSeverity from 'src/components/Alert/AlertEnums';
import { useDispatch, useSelector } from 'react-redux';
import {
  CLEAR_CONTRACT_TRANSACTIONS,
  loadContractTransaction
} from 'src/store/actions/transactionActions';
import PropTypes from 'prop-types';
import { selectTransactionBalance } from 'src/store/selectors/transactionSelectors';
import { formatAmountWithDecimals } from 'src/utils/formatAmout';
import {
  SEND_TERMINATION_LETTER_TO_CLIENT,
  sendTerminationLetterToClientAction
} from 'src/store/actions/contractActions';
import { isLoadingSelector } from 'src/store/selectors/statusSelector';

export const TerminationLetterMenuOptions = [
  {
    label: 'COMMON.SEND_TERMINATION_LETTER_TO_CLIENT',
    key: TerminationLetterOpions.SEND_TO_CLIENT,
    icon: <Send />
  }
];

const TerminationLetterDocumentMenu = ({ contractId }) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [openModal, setOpenModal] = useState('');
  const dispatch = useDispatch();
  const balance = useSelector(selectTransactionBalance);
  const isLoading = useSelector(
    isLoadingSelector([SEND_TERMINATION_LETTER_TO_CLIENT.action])
  );

  const handleOpenMenu = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleOpenSendToClientDialog = () => {
    setOpenModal(TerminationLetterOpions.SEND_TO_CLIENT);
  };

  const handleCloseSendToClientDialong = () => {
    setOpenModal('');
  };

  const selectMenuItemAction = key => {
    switch (key) {
      case TerminationLetterOpions.SEND_TO_CLIENT:
        handleOpenSendToClientDialog();
        break;
      default:
        break;
    }
  };

  const handleSendTerminationLetterToClient = () => {
    dispatch(
      sendTerminationLetterToClientAction(
        contractId,
        handleCloseSendToClientDialong
      )
    );
  };

  useEffect(() => {
    if (open) {
      dispatch(loadContractTransaction(contractId, { page: 0 }));
    }
    return () => {
      dispatch({ type: CLEAR_CONTRACT_TRANSACTIONS });
    };
  }, [dispatch, contractId]);

  return (
    <Box component="div">
      <IconButton
        aria-label="documentsMenu"
        id="documentsMenu"
        onClick={handleOpenMenu}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="termination-letter"
        MenuListProps={{
          'aria-labelledby': 'long-button'
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleCloseMenu}
      >
        {TerminationLetterMenuOptions.map(option => (
          <MenuItem onClick={() => selectMenuItemAction(option.key)}>
            <ListItemIcon>{option.icon}</ListItemIcon>
            {t('COMMON.SEND_TERMINATION_LETTER_TO_CLIENT')}
          </MenuItem>
        ))}
      </Menu>
      <ConfirmationDialog
        open={openModal === TerminationLetterOpions.SEND_TO_CLIENT}
        handleClose={handleCloseSendToClientDialong}
        onSubmit={handleSendTerminationLetterToClient}
        isLoading={isLoading}
        title={t('COMMON.SEND_TERMINATION_LETTER_TO_CLIENT_TITLE')}
      >
        <AlertMessage
          open={balance > 0}
          severity={AlertSeverity.WARNING}
          text={t('COMMON.SEND_TERMINATION_LETTER_TO_CLIENT_WARNING', {
            balance: formatAmountWithDecimals(balance, 2)
          })}
          hideCloseIcon
        />
        <Typography
          sx={theme => ({
            color: theme.palette.text.primary,
            marginTop: 2,
            textAlign: 'justify',
            fontSize: theme.spacing(2.5)
          })}
        >
          {t('COMMON.SEND_TERMINATION_LETTER_TO_CLIENT_DESCRIPTION')}
        </Typography>
      </ConfirmationDialog>
    </Box>
  );
};

TerminationLetterDocumentMenu.propTypes = {
  contractId: PropTypes.string.isRequired
};

export default TerminationLetterDocumentMenu;
